import React, { useCallback, useContext, useMemo } from 'react'
import LineShieldCheckIcon from 'components/Luxkit/Icons/line/LineShieldCheckIcon'
import OrderUpsellTileWithTracking from 'components/Common/OrderUpsellTileWithTracking'
import { getRemainingHoursToPostPurchaseInsuranceBookingProtection } from 'lib/order/orderInsuranceBookingProtectionUtils'
import ModalContext from 'contexts/ModalContext'
import RemainingHoursModal from 'components/Insurance/RemainingHoursModal'

interface Props {
  insuranceBookingProtectioUpsellData: App.InsuranceUpsell;
  onClick: () => void;
  order?: App.Order,
  variant?: 'compact' | 'default';
  onDismiss?: () => void;
}

function InsuranceBookingProtectionUpsellTile(props: Props) {
  const {
    insuranceBookingProtectioUpsellData,
    variant = 'default',
    onDismiss,
    order,
    onClick,
  } = props

  const showModal = useContext(ModalContext)

  const {
    fetchingQuotes,
    fetchingLuxPlusSubscription,
    cheapestQuotePrice,
    cheapestQuoteLuxPlusPrice,
    isEnabledLuxPlusDiscountedInsurance,
  } = insuranceBookingProtectioUpsellData

  const alertText = useMemo(() => {
    if (!order) return
    const remainingHours = getRemainingHoursToPostPurchaseInsuranceBookingProtection(order)
    if (remainingHours > 0) {
      return `Available for next ${remainingHours}h`
    }
  }, [order])

  const alertClickHandler = useCallback(() => {
    showModal(<RemainingHoursModal />)
  }, [showModal])

  return <OrderUpsellTileWithTracking
    title="Cancellation protection"
    description="Receive a 100% refund if you need to cancel for unforeseen events."
    price={cheapestQuotePrice}
    luxPlusPrice={cheapestQuoteLuxPlusPrice}
    priceUnit="person"
    isPriceLoading={fetchingQuotes || (isEnabledLuxPlusDiscountedInsurance && fetchingLuxPlusSubscription)}
    currencyFormat="dynamicDollar"
    IconComponent={LineShieldCheckIcon}
    analyticsSubject="cfmr"
    className="insurance-upsell-tile"
    variant={variant}
    onDismissClick={onDismiss}
    alertText={alertText}
    onAlertClick={alertClickHandler}
    onClick={onClick}
  />
}

export default InsuranceBookingProtectionUpsellTile
